import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column, EmptyScreen } from '~/commonComponents';
import CandidateEmptyScreenIcon from '~/images/candidate-empty-screen-icon.svg';

export const EmptyState = () => (
  <EmptyScreen
    Icon={() => (
      <img
        alt="candidate-empty-screen-icon"
        src={CandidateEmptyScreenIcon}
        height={170}
        width={170}
      />
    )}
    title="No candidates yet"
    description={
      <Column alignItems="center" gap={48} marginBottom={146}>
        <Typography as="span" color={colors.neutral[500]}>
          You haven&apos;t received any applications for this position.
          <br />
          To attract candidates, make sure you&apos;ve posted
          <br />
          enough onsite interviews; this is how dental
          <br />
          professionals apply to your job.
        </Typography>
      </Column>
    }
  />
);
